<div
     class="bg-component-inner border border-secondary-border rounded-xl shadow-md overflow-hidden flex flex-col transition-all duration-300 mb-4 w-full min-w-[300px]">

  <div class="px-4 py-3 bg-alt-background border-b border-secondary-border flex items-center justify-between">
    <div class="flex items-center gap-2">
      <i class="fas fa-network-wired text-[#27272A] dark:text-[#D4D4D8] text-lg"></i>
      <span class="font-bold text-primary-text">{{ config.texts.workflowPlanTitle }}</span>
    </div>
  </div>

  @if (plan.executionState?.status === 'success' || plan.executionState?.status === 'error') {
  <div class="p-4 border-b border-secondary-border"
       [ngClass]="plan.executionState?.status === 'success' ? '!bg-success/10 !text-success' : '!bg-danger/10 !text-danger'">
    <div class="flex items-center gap-2 mb-2">
      <i class="fas"
         [ngClass]="plan.executionState?.status === 'success' ? 'fa-check-circle' : 'fa-exclamation-circle'"></i>
      <span class="font-bold text-sm">
        {{ plan.executionState?.status === 'success' ? 'Workflow Executed Successfully' : 'Workflow Execution Failed' }}
      </span>
    </div>

    @if (plan.executionState?.error) {
    <div class="text-sm font-medium mt-1">{{ plan.executionState?.error }}</div>
    }
  </div>
  }

  <div class="p-6 bg-component-inner flex-1 max-h-[800px] overflow-y-auto custom-scrollbar">
    <nz-timeline>
      @for (task of plan.tasks; track task.description) {
      <nz-timeline-item [nzDot]="customDot">

        <ng-template #customDot>
          <div
               class="w-8 h-8 rounded-full flex items-center justify-center bg-alt-background border border-secondary-border shadow-sm -ml-1">
            <i
               class="fas text-sm {{ getTaskTheme(task.name || task.type).colorClass }} {{ getTaskTheme(task.name || task.type).icon }}"></i>
          </div>
        </ng-template>

        <div class="pl-2 pb-5 flex flex-col gap-1 w-full">
          <div class="flex items-center justify-between gap-2 mb-1 w-full">
            <div class="flex items-center gap-2">
              <nz-tag
                      class="!m-0 text-[10px] font-bold uppercase tracking-wider bg-section-background border-secondary-border text-primary-text shadow-sm">
                {{ getTaskTheme(task.name || task.type).title }}
              </nz-tag>

              @if (task.status === 'completed') {
              <nz-tag
                      class="!m-0 text-[10px] font-bold uppercase tracking-wider !bg-success/10 !text-success !border-success/20 flex items-center gap-1 !rounded-full">
                <i class="fas fa-check-circle"></i> Completed
              </nz-tag>
              } @else if (task.status === 'in-progress') {
              <nz-tag
                      class="!m-0 text-[10px] font-bold uppercase tracking-wider !bg-warning/10 !text-warning !border-warning/20 flex items-center gap-1 !rounded-full">
                <i class="fas fa-circle-notch fa-spin"></i> In Progress
              </nz-tag>
              } @else if (task.status === 'failed') {
              <nz-tag
                      class="!m-0 text-[10px] font-bold uppercase tracking-wider !bg-danger/10 !text-danger !border-danger/20 flex items-center gap-1 !rounded-full">
                <i class="fas fa-times-circle"></i> Failed
              </nz-tag>
              } @else {
              <nz-tag
                      class="!m-0 text-[10px] font-bold uppercase tracking-wider !bg-component-inner !text-secondary-text !border-secondary-border flex items-center gap-1 !rounded-full">
                <i class="fas fa-clock"></i> Pending
              </nz-tag>
              }
            </div>

            <div class="flex items-center gap-2">
              <!-- @if (task.status === 'completed') { -->
              <button (click)="toggleTaskDetails(task.description)"
                      class="text-secondary-text hover:text-primary transition-colors focus:outline-none">
                <i class="fas"
                   [ngClass]="isTaskCollapsed(task.description) ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
              </button>
              <!-- } -->
            </div>
          </div>

          @if (!isTaskCollapsed(task.description)) {
          <p class="text-sm text-primary-text leading-relaxed font-medium mt-1 transition-all">
            {{ task.description }}
          </p>
          }
        </div>

      </nz-timeline-item>
      }
    </nz-timeline>

    @if (isAllStepsCompleted) {
    <div class="px-4 py-3 bg-success/10 border-t border-success/20 flex items-center gap-3 animate-fade-in">
      <i class="fas fa-check-circle text-success text-lg"></i>
      <div class="flex flex-col">
        <span class="text-xs font-bold text-success uppercase tracking-wider"
              i18n="@@aiChat.workflowCompleteTitle">Workflow Complete</span>
        <span class="text-[11px] text-success/80"
              i18n="@@aiChat.workflowCompleteDesc">All steps executed successfully.</span>
      </div>
    </div>
    }
  </div>
  @if (!isConfirmed) {
  <div class="px-4 py-3 bg-alt-background border-t border-secondary-border flex justify-end">
    <button nz-button
            [nzLoading]="plan.executionState?.status === 'loading'"
            [disabled]="plan.executionState?.status === 'success' || plan.executionState?.status === 'loading'"
            (click)="onExecuteClick()"
            class="bg-[#27272A] hover:bg-[#3F3F46] dark:bg-[#D4D4D8] dark:hover:bg-[#E4E4E7] text-[#FAFAFA] dark:text-[#18181B] border border-black/10 dark:border-white/10 shadow-xs flex items-center gap-2 rounded-[6px] font-medium text-[13px] py-1 px-3.5 transition-colors cursor-pointer disabled:cursor-not-allowed disabled:opacity-40">
      @if (plan.executionState?.status !== 'loading') { <i class="fas fa-play text-xs"></i> }
      <span>&nbsp;{{ config.texts.executePlanButton }}</span>
    </button>
  </div>
  }
</div>